import { render, staticRenderFns } from "./referral-code-quick.vue?vue&type=template&id=785e6366&scoped=true"
import script from "./referral-code-quick.vue?vue&type=script&lang=js"
export * from "./referral-code-quick.vue?vue&type=script&lang=js"
import style0 from "./referral-code-quick.vue?vue&type=style&index=0&id=785e6366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e6366",
  null
  
)

export default component.exports